/**
 * Where the Pinksy API is.
 *
 * 🔴 **SAME-ORIGIN BY DEFAULT** (D29, hardrules §5: never a host, never a localhost API base).
 * `/api/pinksy` is what the shell's own nginx proxies to the Pinksy app
 * (`docker/shell/nginx.conf.template`) and what `tools/pinksy.sh build-web` exports, so a bundle
 * built with `VITE_PINKSY_API` unset — a plain `npm run build` — carries no hostname instead of a
 * dev machine's port. A raw `npm run dev` gets the same path: `apps/shell/vite.config.ts` proxies it
 * to :7400.
 *
 * It lived in `tenant/resolve.ts` until D118, because that file made the first call of every boot
 * and so had to know the base. Twelve modules imported it from there and none of them wanted a
 * tenant; deleting the resolve call is what made the misfiling visible.
 */
export const DEFAULT_API_BASE_URL = "/api/pinksy";

export function apiBaseUrl(env: Pick<ImportMetaEnv, "VITE_PINKSY_API"> = import.meta.env): string {
  const configured = (env.VITE_PINKSY_API ?? "").trim();
  return (configured || DEFAULT_API_BASE_URL).replace(/\/+$/, "");
}

export const API_BASE_URL = apiBaseUrl();
